import React from 'react'
import Hero from './partials/Hero'

import About from './partials/About'

const HomePage = () => {
  return (
    <div>
      <Hero/>
      <About/>
    </div>
  )
}

export default HomePage